// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__NGPYQ","col":"styles_col__1KXOJ"};